import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './NavDropdown.css';


const NavDropdown = ({ label, items, align = 'right' }) => {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    if (!open) return;

    const handleClickOutside = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    const handleEsc = (e) => {
      if (e.key === 'Escape') setOpen(false);
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEsc);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEsc);
    };
  }, [open]);

  return (
    <div className={`nav-dropdown ${open ? 'nav-dropdown-open' : ''}`} ref={wrapRef}>
      <button
        type="button"
        className="nav-dropdown-trigger"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
        aria-haspopup="true"
      >
        {label}
        <span className="nav-dropdown-chevron" aria-hidden="true">▾</span>
      </button>

      <div
        className={`nav-dropdown-menu nav-dropdown-menu-${align}`}
        role="menu"
      >
        {items.map((item) => (
          <Link
            key={item.to}
            to={item.to}
            className="nav-dropdown-item"
            role="menuitem"
            onClick={() => setOpen(false)}
          >
            {item.icon && (
              <span className="nav-dropdown-item-icon" aria-hidden="true">
                {item.icon}
              </span>
            )}
            <span className="nav-dropdown-item-body">
              <span className="nav-dropdown-item-label">{item.label}</span>
              {item.description && (
                <span className="nav-dropdown-item-desc">{item.description}</span>
              )}
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default NavDropdown;
